(function () {
    'use strict';

    angular.module('FotocApp')
        .component('barcode', {
            template: "<div><svg class='barcode' style='height: 100%'></svg></div>",
            bindings: { sin: '@' },
            controller: ['$element', function ($element) {

                this.$onInit = function () {

                    JsBarcode(angular.element($element)[0].querySelector('.barcode'), this.sin, {
                        displayValue: false,
                        width: 0.8,
                        height: 30,
                        margin: 0.2
                    });


                };

            }]
        })
})();